<template>
    <CameraModule v-if="model" @update="cameraEvt" @start="startEvt" :blue="blue" :purple="purple" :resolution="resolution">
        <div style="position: absolute; width: 100%; height: 100%; pointer-events: none; top: 0">
                <template  v-for="(object, index) in result" :key="index">
                    <!-- v-if="index == 0" -->
                    <div class="box" 
                        :style="{
                            top: `${Math.max(0, object.minY) * this.resolution}px`, 
                            left: `${Math.max(0, object.minX) * this.resolution}px`, 
                            width: `${Math.min(1, object.width) * this.resolution}px`, 
                            height: `${Math.min(1, object.height) * this.resolution}px`}">
                        <div class="label">
                            {{model.labels? model.labels[object.class] : object.class}} 
                            {{object.score}}%
                        </div>
                    </div>
                </template>
            </div>
    </CameraModule>
</template>

<script>
import CameraModule from '@/tm/Camera'
import Camera from '@/tm/Camera/scripts/camera.js';
import CustomDetection from '@/utils/src/CustomDetection';

export default {
    name: 'ImageModel',
    emits: ['result', 'start'],
    props:{
        blue: {
            type: Boolean,
            default: false,
        },
        purple: {
            type: Boolean,
            default: false,
        },
        model: {
            type: Object,
            default: new CustomDetection()
        },
        slow: {
            type: Number,
            default: 0
        },
        resolution: {
            type: Number,
            default: 240
        }
    },
    components: {
        CameraModule,
    },
    data(){
        return {
            slowCounter: 0,
            wait: false,
            result: null
        }
    },
    methods: {
        startEvt(){
            this.$emit('start')
        },
        async cameraEvt(canvas){
            if (!this.model || !this.model.model || this.wait) {
                return
            }
            if (this.slow) {
                if (this.slowCounter < this.slow) {
                    this.slowCounter++
                    return 
                } else {
                    this.slowCounter = 0;
                }
            }
            let result
            result = await this.model.predict(canvas);
            this.result = result
            this.$emit('result', result, canvas) 
        },
    }
}
</script>

<style scoped>
.box{
    position: absolute; border: 1px dotted white; 
    background: rgba(112,83,163, 0.5); border-radius: 0;
    box-sizing: border-box;
}

.box .label{
    width: max-content; height: max-content; 
    background: rgba(112,83,163); color: white; 
    border-radius: 0; padding: 5px; max-height: 30px; border: 1px dotted white; 
    white-space: nowrap; position: absolute; transform: translateY(-100%);
    left: -1px;
}
</style>